module.exports = __webpack_public_path__ + "images/signup-guide-876d0abcb2d69efcdcf180f5482f52c3.png";